/***
 Created by IntelliJ IDEA.
 User: xiexy
 Date: 2019/6/12
 ***/

import JSEncrypt from 'jsencrypt';
import CryptoJS from 'crypto-js';
import hex_sha1 from 'js-sha1';
import md5 from 'md5';
import keyou from '../../static/keyou-encrypt/keyou-crypto-min';
import {browser} from "./index";

//科友秘钥
export const pksm2 = '9CD9EE599985C650606E57E6C5378FE7E56F8D6A825A9B2F272257E06DA83269B8DF8C9434CF266B52DD521C1C8F37AA538DFC48E2330ECAA01' + 'C9918945B028094D7B8BCF7B925AA502F968C0CC24E6C037C88512023061A47364C4918918DED365E03924D0D5D7565B0665298E80B84C2333C0F731E8734E198735FBDE9C4EC2879177C4F0DBF26C94E2BFCC66D0B61';
export const pk = '32C6AC4EA36D6672B2191816D3465EF0E73BE35BEB3945909077E32B849F238CAF29596D789D47381A8486EE239E4D93AA3306C51DFBE9D18517FC3776B47B9F'
/**
 * 科友关键字加密
 * @param val
 */
export const keyouEncrypt = val => {
  let x2 = keyou.util.UTF8.parse(val);
  let r = keyou.DigitalEnvelope.encrypt(x2, pksm2, '');
  return r.KeyCipher + '_' + r.MessageCipher;
};

//公钥
const publicKey = "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDYVoYd8XsHJZ6/M0X4NwDO0Qe/QVlMRn2e7IRcPUFgvHidQXI2/Gcfu+bLPT+gboOGqAcpGrUFwolJxlyT/YJkeDKgBfGnVw88u2dNMefLXwDULs275CjnZDXx7L068VegFPIS8yu8iOh1pljQRqNdaICKF2QrvFz/f/1w8kH61wIDAQAB";
//公共参数
const commParams = {
  channel: browser.versions.ios ? '1' : '2',
  app_ver_no: '1',
  model: 'web',
  term_sys_ver: '1'
};
//待加密数组
const encryptParams = [
  "login_name",
  "email",
  "cert_no",
  "certNo",
  "card_no",
  "pwd",
  "parent_user_id"
];

/**
 * 入参加密签名处理
 * @param json
 */
export const commInHandle = {
  filter(json) {
    for (let param1 in commParams) {
      json[param1] = commParams[param1];
    }
    for (let param2 in json) {
      if (!json[param2] || json[param2].length == 0) {
        if (typeof json[param2] != "number")
          delete json[param2];
      }
    }
    return json;
  },
  encrypt(json) {
    this.filter(json);
    const encrypt = new JSEncrypt();
    encrypt.setPublicKey(publicKey);
    let rand = randomWord(true, 24, 24).toUpperCase();
    let key = encrypt.encrypt(rand);//用于3DES加密的key，并且要传给接口
    encryptParams.forEach(item => {
      if (json[item]) {
        json[item] = encryptByDES(rand, json[item].toString());
      }
    });
    json["dec_key"] = key;
    return json;
  },
  sign(json) {
    this.filter(json);
    let keyArr = Object.keys(json);
    if (!Object.values) Object.values = obj => {//如果要Object.values兼容不支持它的旧环境(比如vivo x7)
      if (obj !== Object(obj))
        throw new TypeError('Object.values called on a non-object');
      let val = [];
      for (let key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          val.push(obj[key]);
        }
      }
      return val;
    };
    let signArr = Object.values(json);
    keyArr.forEach((item, index) => {
      if (item.indexOf('list') > -1) {
        keyArr.splice(index, 1);
        signArr.splice(index, 1);
        let list = JSON.parse(JSON.stringify(json[item]));
        for (let i = 0; i < list.length; i++) {
          let listSign = Object.values(list[i]).join('');
          list[i]["key"] = Object.keys(list[i]).join(',');
          list[i]["sign"] = hex_sha1(md5(listSign + "123456").toUpperCase()).toUpperCase();
        }
        json[item] = list;
      }
    });
    json["key"] = keyArr.join(',');
    json["sign"] = hex_sha1(md5(signArr.join('') + "123456").toUpperCase()).toUpperCase();
    return json;
  }
};

/**
 * randomWord 产生任意长度随机字母数字组合
 * randomFlag-是否任意长度 min-任意长度最小位[固定位数] max-任意长度最大位
 */
export const randomWord = (randomFlag, min, max) => {
  let str = "",
    range = min,
    arr = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
  // 随机产生
  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min;
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1));
    str += arr[pos];
  }
  return str;
};

/**
 *针对3des 模式ECB，填充Pkcs7 的封装加密方法
 *参数含义：key 密钥，，message入参值
 */
const encryptByDES = (key, message) => {
  let keyHex = CryptoJS.enc.Utf8.parse(key),
    encrypted = CryptoJS.TripleDES.encrypt(message, keyHex, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
  return encrypted.toString();
};



// WEBPACK FOOTER //
// ./src/utils/cryptography.js